import React from 'react';

const Footer = (props) => {
    return(
        <footer className="clearfix">
            <a target="_blank" rel="noopener noreferrer" href="https://github.com/jeffersonRibeiro/react-lista-sugerida">
                <i className="fa fa-github"></i> <span className="author">Jefferson Ribeiro</span>
            </a>
        </footer>
    )
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js